import Loadable from './Loadable';

const PATH_PREFIX = '/procurement/:companyID';

export default [
  {
    name: 'procurement.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
    exact: true,
    component: Loadable(import('../ui/apps/procurement/dashboard')),
  },
  /** Incoming* */
  {
    name: 'procurement.incoming.enquiries',
    path: `${PATH_PREFIX}/incoming/ask_for_quote`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/askForQuote/list')
    ),
  },
  {
    name: 'procurement.incoming.enquiry',
    path: `${PATH_PREFIX}/incoming/ask_for_quote/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/askForQuote/detail')
    ),
  },
  {
    name: 'procurement.incoming.request_for_quotes',
    path: `${PATH_PREFIX}/incoming/request_for_quote`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/requestForQuote/list')
    ),
  },
  {
    name: 'procurement.incoming.request_for_quote',
    path: `${PATH_PREFIX}/incoming/request_for_quote/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/requestForQuote/detail')
    ),
  },
  {
    name: 'procurement.incoming.quotations',
    path: `${PATH_PREFIX}/incoming/quotation`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/quotation/list')
    ),
  },
  {
    name: 'procurement.incoming.quotation',
    path: `${PATH_PREFIX}/incoming/quotation/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/quotation/detail')
    ),
  },
  {
    name: 'procurement.incoming.orders',
    path: `${PATH_PREFIX}/incoming/order`,
    exact: true,
    component: Loadable(import('../ui/apps/procurement/incoming/order/list')),
  },
  {
    name: 'procurement.incoming.order',
    path: `${PATH_PREFIX}/incoming/order/:docID`,
    exact: true,
    component: Loadable(import('../ui/apps/procurement/incoming/order/detail')),
  },
  {
    name: 'procurement.incoming.delivery_notes',
    path: `${PATH_PREFIX}/incoming/delivery_note`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/deliveryNote/list')
    ),
  },
  {
    name: 'procurement.incoming.delivery_note',
    path: `${PATH_PREFIX}/incoming/delivery_note/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/incoming/deliveryNote/detail')
    ),
  },
  /** Outgoing* */
  {
    name: 'procurement.outgoing.enquiries',
    path: `${PATH_PREFIX}/outgoing/ask_for_quote`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/askForQuote/list')
    ),
  },
  {
    name: 'procurement.outgoing.enquiry',
    path: `${PATH_PREFIX}/outgoing/ask_for_quote/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/askForQuote/detail')
    ),
  },
  {
    name: 'procurement.outgoing.request_for_quotes',
    path: `${PATH_PREFIX}/outgoing/request_for_quote`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/requestForQuote/list')
    ),
  },
  {
    name: 'procurement.outgoing.request_for_quote',
    path: `${PATH_PREFIX}/outgoing/request_for_quote/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/requestForQuote/detail')
    ),
  },
  {
    name: 'procurement.outgoing.quotations',
    path: `${PATH_PREFIX}/outgoing/quotation`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/quotation/list')
    ),
  },
  {
    name: 'procurement.outgoing.quotation',
    path: `${PATH_PREFIX}/outgoing/quotation/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/quotation/detail')
    ),
  },
  {
    name: 'procurement.outgoing.orders',
    path: `${PATH_PREFIX}/outgoing/order`,
    exact: true,
    component: Loadable(import('../ui/apps/procurement/outgoing/order/list')),
  },
  {
    name: 'procurement.outgoing.order',
    path: `${PATH_PREFIX}/outgoing/order/:docID`,
    exact: true,
    component: Loadable(import('../ui/apps/procurement/outgoing/order/detail')),
  },
  {
    name: 'procurement.outgoing.delivery_notes',
    path: `${PATH_PREFIX}/outgoing/delivery_note`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/deliveryNote/list')
    ),
  },
  {
    name: 'procurement.outgoing.delivery_note',
    path: `${PATH_PREFIX}/outgoing/delivery_note/:docID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/procurement/outgoing/deliveryNote/detail')
    ),
  },
];
